import { render } from "./FeaturedArtists.vue?vue&type=template&id=7c268874&scoped=true"
import script from "./FeaturedArtists.vue?vue&type=script&lang=js"
export * from "./FeaturedArtists.vue?vue&type=script&lang=js"

import "./FeaturedArtists.vue?vue&type=style&index=0&id=7c268874&scoped=true&lang=css"
import "./FeaturedArtists.vue?vue&type=style&index=1&id=7c268874&scoped=true&lang=css"
import "./FeaturedArtists.vue?vue&type=style&index=2&id=7c268874&scoped=true&lang=css"
import "./FeaturedArtists.vue?vue&type=style&index=3&id=7c268874&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c268874"]])

export default __exports__